export const BILL_TYPE_HELP_LANG_RESOURCES = {
    "zh-CHS": {
        "code": "编号",
        "name": "名称",
        "busineseCategory": "业务种类",
        "module": "模块",
        "busineseType": "业务类型",
        "collapse": "收起",
        "expand": "展开",
        "loading": "加载中",
        "allColumns": "所有列",
    },
    "en": {
        "code": "Code",
        "name": "Name",
        "busineseCategory": "Businese Category",
        "module": "Module",
        "busineseType": "Businese Type",
        "collapse": "Collapse",
        "expand": "Expand",
        "loading": "Loading",
        "allColumns": "All Columns",
    },
    "zh-CHT": {
        "code": "編號",
        "name": "名稱",
        "busineseCategory": "業務種類",
        "module": "模塊",
        "busineseType": "業務類型",
        "collapse": "收起",
        "expand": "展開",
        "loading": "加載中",
        "allColumns": "所有列",
    }
};